import React from "react";
import { motion } from "framer-motion";

// The platforms & models our products are engineered on.
const tech = [
  { name: "Google", color: "#4285F4" },
  { name: "Meta", color: "#0866FF" },
  { name: "Microsoft", color: "#00A4EF" },
  { name: "OpenAI", color: "#10A37F" },
  { name: "Anthropic", color: "#D97757" },
  { name: "Sarvam AI", color: "#7C3AED" },
  { name: "Gnani.ai", color: "#F59E0B" },
  { name: "Databricks", color: "#FF3621" },
  { name: "Vercel", color: "#111111" },
  { name: "AWS", color: "#FF9900" },
  { name: "DigitalOcean", color: "#0080FF" },
  { name: "NVIDIA", color: "#76B900" },
  { name: "Hugging Face", color: "#FFB000" },
  { name: "Cloudflare", color: "#F38020" },
  { name: "MongoDB", color: "#47A248" },
  { name: "Supabase", color: "#3ECF8E" },
  { name: "Stripe", color: "#635BFF" },
  { name: "Razorpay", color: "#0C2451" },
  { name: "Firebase", color: "#FFA000" },
  { name: "GitHub", color: "#181717" },
  { name: "Docker", color: "#2496ED" },
  { name: "LangChain", color: "#1C8C7A" },
];

function ComapnyComponent() {
  return (
    <div className="tech-stack-section">
      <div className="container text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <div className="section-badge section-badge-light">Our Technology Stack</div>
          <h3>
            Built With <span className="accent-grad">World-Class Technology</span>
          </h3>
          <p className="tech-stack-subtitle">
            Our products are engineered on the same platforms and AI models that
            power the world's most advanced companies.
          </p>
        </motion.div>
      </div>

      <div className="tech-marquee">
        <div className="tech-track">
          {[...tech, ...tech].map((t, i) => (
            <span className="tech-pill" key={i} aria-hidden={i >= tech.length}>
              <span className="tech-dot" style={{ background: t.color }} />
              {t.name}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ComapnyComponent;
